function t(e){return(...n)=>!e(...n)}export{t as not};
//# sourceMappingURL=predicates.mjs.map